import { useShallow } from "zustand/react/shallow";

import AiChatHistorySidePanel from "components/AiChat/History/SidePanel";
import { AiChatSession } from "components/AiChat/types";
import { useContainerBreakpoint } from "hooks/useContainerBreakpoint";

import { ASSISTANT_PANEL_CONTAINER } from "../../Layout/constants";
import { HISTORY_SIDE_PANEL_BREAKPOINT } from "../constants";
import useChatStore from "../store/useStore";

type AssistantPanelHistorySidePanelProps = {
  deleteChat: (chatId: string) => void;
  chats: AiChatSession[];
  loading: boolean;
  onSelectChat: (chatId: string) => void;
};

const AssistantPanelHistorySidePanel = (props: AssistantPanelHistorySidePanelProps) => {
  const { isHistoryOpen, currentChatId } = useChatStore(
    useShallow((state) => ({
      isHistoryOpen: state.isHistoryOpen,
      currentChatId: state.chat?.id ?? "",
    }))
  );
  const isWide = useContainerBreakpoint(ASSISTANT_PANEL_CONTAINER, HISTORY_SIDE_PANEL_BREAKPOINT);

  if (!isWide || !isHistoryOpen) {
    return null;
  }

  return <AiChatHistorySidePanel {...props} currentChatId={currentChatId} />;
};

export default AssistantPanelHistorySidePanel;
